var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0083 46.4119C36.401 46.4119 46.4473 36.3656 46.4473 23.9729C46.4473 11.5802 36.401 1.53394 24.0083 1.53394C11.6156 1.53394 1.56934 11.5802 1.56934 23.9729C1.56934 36.3656 11.6156 46.4119 24.0083 46.4119Z",
    fill: "#374151"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33384_13945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2592 34.8184C18.1033 34.8184 16.0725 33.9904 14.5572 32.4751C13.0262 30.9598 12.1982 28.9446 12.1982 26.8043C12.1982 24.6641 13.0262 22.6489 14.5572 21.1492C16.0725 19.6339 18.1033 18.7903 20.2592 18.7903H26.5079C26.7267 18.7903 26.8985 18.9465 26.9454 19.1496L27.2266 20.3056H29.6636L29.9448 19.1496C29.9916 18.9465 30.1791 18.7903 30.3978 18.7903H34.5064V24.7266L28.1795 25.6015C28.2264 25.992 28.2576 26.3982 28.2576 26.8043C28.2732 31.2254 24.6802 34.8184 20.2592 34.8184ZM35.0375 18.7903H36.8497C37.0996 18.7903 37.3183 19.009 37.3183 19.2589V23.9455C37.3183 24.1799 37.1465 24.3829 36.9122 24.4142L35.0375 24.6641V18.7903ZM20.2592 30.0381C22.0401 30.0381 23.4773 28.5852 23.4773 26.8043C23.4773 25.0234 22.0401 23.5862 20.2592 23.5862C18.447 23.5862 17.0254 24.9922 17.0254 26.8043C17.0254 28.6165 18.447 30.0381 20.2592 30.0381ZM20.2592 24.1017C21.7433 24.1017 22.9618 25.3203 22.9618 26.8043C22.9618 28.3041 21.7433 29.5069 20.2592 29.5069C18.7438 29.5069 17.5566 28.3197 17.5566 26.8043C17.5566 25.289 18.7438 24.1017 20.2592 24.1017Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4296 16.0876C28.164 16.0876 27.9609 15.8845 27.9609 15.6189V13.6505C27.9609 13.385 28.164 13.1819 28.4296 13.1819C28.6795 13.1819 28.8983 13.385 28.8983 13.6505V15.6189C28.8983 15.8845 28.6795 16.0876 28.4296 16.0876Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8663 17.228C30.7726 17.228 30.6789 17.2124 30.6008 17.1499C30.382 16.9937 30.3352 16.7125 30.4914 16.4938L31.7412 14.7285C31.8818 14.5254 32.1786 14.4785 32.3817 14.6191C32.6004 14.7754 32.6472 15.0566 32.491 15.2753L31.2569 17.0405C31.1631 17.1655 31.0225 17.228 30.8663 17.228Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0855 17.228C25.9449 17.228 25.7887 17.1655 25.6949 17.0405L24.4452 15.2753C24.3046 15.0565 24.3514 14.7597 24.5701 14.6191C24.7732 14.4629 25.07 14.5254 25.2106 14.7285L26.4604 16.4938C26.6166 16.7125 26.5697 17.0093 26.351 17.1499C26.2729 17.2124 26.1792 17.228 26.0855 17.228Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0259 29.5068H11.1513C10.8857 29.5068 10.6826 29.3037 10.6826 29.0381V24.5702C10.6826 24.3046 10.8857 24.1016 11.1513 24.1016H13.0259C13.2915 24.1016 13.4946 24.3046 13.4946 24.5702C13.4946 24.8358 13.2915 25.0389 13.0259 25.0389H11.6199V28.5694H13.0259C13.2915 28.5694 13.4946 28.7881 13.4946 29.0381C13.4946 29.3037 13.2915 29.5068 13.0259 29.5068Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4294 19.6337C27.6952 19.6337 27.0703 18.9776 27.0703 18.2278C27.0703 17.4623 27.6639 16.8687 28.4294 16.8687C29.2261 16.8687 29.8354 17.4467 29.8354 18.2278C29.8354 18.9932 29.1949 19.6337 28.4294 19.6337Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33384_13945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 26.6667,
    fill: "white",
    transform: "translate(10.667 10.6667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/coach.c701b2b98a850e65313cba4682a83d28.svg";
export { ForwardRef as ReactComponent };